import { connect } from "react-redux"

import ViewFormActionButtonsWidget from "./ViewFormActionButtonsWidget"

export default function buildViewFormActionButtonsWidgetContainer(
    setEditModeActionCreator,
    presentationAccessor,
    editModeAccessor = "can_edit",
    deletePermission,
    itemDeleteRequestActionCreator,
    itemType
) {
    const mapStateToProps = ({ presentation, authentication }) => ({
        canEdit:
            (editModeAccessor === true ||
                presentation[presentationAccessor].workingModel[
                    editModeAccessor
                ]) &&
            !!presentation[presentationAccessor].workingModel.id,
        canDelete:
            typeof deletePermission === "function"
                ? deletePermission({ presentation, authentication })
                : authentication.permissions.indexOf(deletePermission) !== -1,
        showDelete: !!deletePermission,
        activeId: presentation[presentationAccessor].activeId,
        isDeleting: presentation[presentationAccessor].isDeletingItem,
        name: presentation[presentationAccessor].workingModel.name,
        type: itemType,
    })

    const mapDispatchToProps = (dispatch) => ({
        onEdit: () => dispatch(setEditModeActionCreator(true)),
        onDelete: (id) => dispatch(itemDeleteRequestActionCreator(id)),
    })

    return connect(
        mapStateToProps,
        mapDispatchToProps
    )(ViewFormActionButtonsWidget)
}
